import router from 'next/router';

//* HOCs
import { withUIContext, withUserContext } from 'context'

//* Components
import { Text, CustomLink, Icon } from 'components/common'
import { SubmitReportPopup, DeleteDraftPopup } from 'components/pages'

const Actions = (props) => {

    const { id, slug, title, debateCreator, reportPopup, setSharePopup, setReportPopup, openPopup, status, isLoggedIn, currentUser } = props

    const handleDeletePopUp = () => {
        openPopup(<DeleteDraftPopup />, { debateId: id })
    }

    const handleReportPopUp = () => {
        if (!isLoggedIn) {
            router.push(`${router.asPath}?c=login`)
        } else {
            openPopup(<SubmitReportPopup />, {
                url: `/debate/${slug}`,
                title: title
            })
        }
    }

    return (
        <div className='report block flexBox alignMiddle'>
            <Icon
                className='darkGrey cursorPointer op-burgerDots icon-pop'
                onClick={() => { setReportPopup(!reportPopup); setSharePopup(false) }}
            />
            {status !== 'draft' ? (
                <div className={`report-popup pop flexBoxColumn ${reportPopup ? 'active' : ''}`}>
                    <>
                        {debateCreator.id != currentUser?.id && (
                            <Text
                                tag='h5'
                                className='sharer PopReg h5 cursorPointer'
                                text='Report'
                                onClick={handleReportPopUp}
                            />
                        )}
                        <CustomLink url={`/${debateCreator.username}`}>
                            <Text tag='h5' className='sharer PopReg h5' text='Go to creators page' />
                        </CustomLink>
                    </>
                </div>
            ) : (
                <div className={`report-popup pop delete flexBoxColumn ${reportPopup ? 'active' : ''}`}>
                    <Text
                        tag='h5'
                        className='sharer PopReg h5 cursorPointer'
                        text='Delete'
                        onClick={handleDeletePopUp}
                    />
                </div>
            )}
        </div>
    )
}

export default withUIContext(withUserContext(Actions, ['isLoggedIn', 'currentUser']), ['openPopup'])